/**
 * Stammdaten aus "Firmenfahrzeug Nutzungsvereinbarung Nutzungsaenderung.xlsx"
 * (Tabellenblaetter "Gesellschaften", "Budgetgruppen", "Dropdown").
 */

export interface CompanySeed {
  name: string;
  city: string;
}

export const COMPANIES: CompanySeed[] = [
  { name: 'Apleona GmbH', city: 'Neu-Isenburg' },
  { name: 'APL Alpha Verwaltungs GmbH', city: 'Frankfurt am Main' },
  { name: 'Apleona R&M Ausbau GmbH', city: 'München' },
  { name: 'Apleona Wolfferts GmbH', city: 'Köln' },
  { name: 'Apleona Infra Services GmbH', city: 'Oberhausen' },
  { name: 'Apleona HSG Event Services GmbH', city: 'Neu-Isenburg' },
  { name: 'Apleona MT Services GmbH', city: 'Neu-Isenburg' },
  { name: 'Apleona BS GmbH', city: 'Neu-Isenburg' },
  { name: 'Apleona ITS GmbH', city: 'Neu-Isenburg' },
  { name: 'Apleona Nordost GmbH', city: 'Neu-Isenburg' },
  { name: 'Apleona Mitte-West GmbH', city: 'Neu-Isenburg' },
  { name: 'Apleona Südost GmbH', city: 'Neu-Isenburg' },
  { name: 'Apleona Südwest GmbH', city: 'Neu-Isenburg' },
  { name: 'Apleona WIS GmbH', city: 'Neu-Isenburg' },
  { name: 'Apleona Gebäudetechnik GmbH', city: 'Hanau' },
  { name: 'Apleona Security & Services GmbH', city: 'Neu-Isenburg' },
  { name: 'Karl Früh GmbH', city: 'Berlin' },
  { name: 'Apleona Real Estate GmbH', city: 'Frankfurt am Main' },
  { name: 'Gegenbauer Holding Verwaltung SE', city: 'Berlin' },
  { name: 'Gegenbauer Holding SE & Co. KG', city: 'Berlin' },
  { name: 'Apleona R&M Ausbau Berlin GmbH', city: 'Berlin' },
  { name: 'Apleona R&M Ausbau Düsseldorf GmbH', city: 'Düsseldorf' },
  { name: 'Apleona R&M Ausbau Frankfurt GmbH', city: 'Rödermark' },
  { name: 'Apleona R&M Ausbau Hamburg GmbH', city: 'Hamburg' },
  { name: 'Apleona R&M Ausbau Mannheim GmbH', city: 'Mannheim' },
  { name: 'Apleona R&M Ausbau München GmbH', city: 'München' },
  { name: 'Apleona R&M Ausbau Stuttgart GmbH', city: 'Schönaich' },
  { name: 'Apleona Carecatering GmbH', city: 'Oberhausen' },
  { name: 'Apleona Careclean GmbH', city: 'Oberhausen' },
  { name: 'Apleona Careservices GmbH', city: 'Oberhausen' },
  { name: 'Apleona Cleaning GmbH', city: 'Neu-Isenburg' },
  { name: 'AAS Aviation & Airport Services GmbH', city: 'Berlin' },
  { name: 'Velomax Berlin Hallenbetriebs GmbH', city: 'Berlin' },
  { name: 'GSZ Gebäudeservice und Sicherheitszentrale GmbH', city: 'Berlin' },
  { name: 'Gründlich GmbH', city: 'Berlin' },
  { name: 'Penta Gebäudeservice GmbH', city: 'Berlin' },
  { name: 'Apleona Wohnservice GmbH', city: 'Berlin' },
  { name: 'RGM Retail GmbH', city: 'Düsseldorf' },
  { name: 'RGM Maintenance & Service GmbH', city: 'Düsseldorf' },
  { name: 'Apleona Industrial Facility Management GmbH', city: 'Bochum' },
  { name: 'KAMB Elektrotechnik GmbH', city: 'Ludwigshafen' },
  { name: 'Kluge Gebäudemanagement GmbH', city: 'Dresden' },
  { name: 'fmsc GmbH', city: 'Bochum' },
];

/** Budgetgruppen laut Dropdown-Blatt ("E" = Elektro-Variante). */
export const BUDGET_GROUPS = [
  '1E',
  '2E',
  '3',
  '3E',
  '4',
  '4E',
  '5',
  '5E',
  '6',
  '6E',
  'Nutzfahrzeug',
  'Nutzfahrzeug-Elektro',
  'Poolfahrzeug',
  'Poolfahrzeug-Elektro',
] as const;
export type BudgetGroup = (typeof BUDGET_GROUPS)[number];

/** Poolfahrzeug-Budgetgruppen -> Fahrzeug wird automatisch als POOL gefuehrt. */
export const POOL_BUDGET_GROUPS: string[] = ['Poolfahrzeug', 'Poolfahrzeug-Elektro'];

/**
 * Zieladresse aus dem Original-Formular:
 * "Nutzerwechsel komplett ausgefuellt & unterschrieben an: apleona@carsync.de"
 */
export const CARSYNC_MAIL = 'apleona@carsync.de';

/** Stand der Dienstwagenrichtlinie laut Formularfuss. */
export const DIENSTWAGENRICHTLINIE_STAND = '01.04.2026';

/** Ident-Nummern der Papiervorlagen - werden in die PDF-Fusszeile uebernommen. */
export const FORM_IDENT = {
  RUECKGABE_PKW: 'AP FO PU 52389 001/04.2026 de',
  UEBERGABE_LCV: 'AP FO PU 52397 001/04.2026 de',
  NUTZERWECHSEL: 'AP FO HR 517 005/05.2026 de',
} as const;

/** Schadensdefinition - woertlich aus den Vorlagen, erscheint auf jedem Protokoll. */
export const SCHADENSDEFINITION: { titel: string; text: string }[] = [
  {
    titel: 'Kratzer / Schrammen',
    text: 'Alle offensichtlichen Kratzer und Schrammen mit einer Größe von mehr als 10 mm bzw. weniger als 10 mm, wenn das darunterliegende Metall/Plastik zu sehen ist.',
  },
  {
    titel: 'Delle',
    text: 'Jegliche Art der Verformung eines Karosserieteils oder ein Spalt zwischen Karosserieteilen von mehr als 10 mm.',
  },
  {
    titel: 'Glas',
    text: 'Jede Art von Bruch oder Riss, alle Risse an Beleuchtung und Risse in Spiegeln.',
  },
  { titel: 'Felgen', text: 'Schäden mit einer Länge von mehr als 10 mm.' },
  { titel: 'Radkappen', text: 'Schäden mit einer Länge von mehr als 10 mm.' },
  {
    titel: 'Reifen',
    text: 'Alle Reifenschäden, einschließlich Schäden an der Reifenflanke, Löcher und wenn das Fahrzeug mit einem platten Reifen gefahren wurde.',
  },
  { titel: 'Schlösser', text: 'Alle Schäden.' },
  { titel: 'Vorsatz', text: 'Schäden, die vorsätzlich oder durch grobe Fahrlässigkeit entstanden sind.' },
];

export const HINWEIS_LEASINGENDE =
  'Am Leasingende können Kosten für die Ersatzbeschaffungen von fehlenden Unterlagen oder Teile, sowie Innenreinigung aufgrund starker Verschmutzung, aber auch Kratzer, Brandlöcher im Innenbereich in Rechnung gestellt werden.';

export const HINWEIS_DIENSTWAGENRICHTLINIE = `Mit Unterzeichnung dieses Protokolls bestätigt der/die Mitarbeiter/in, dass ihm/ihr die gültige Fassung der Dienstwagenrichtlinie (Stand: ${DIENSTWAGENRICHTLINIE_STAND}) ausgehändigt und erläutert wurde. Diese Dienstwagenrichtlinie ist Bestandteil des bestehenden Arbeitsverhältnisses und entfaltet ab dem vorgenannten Datum rechtliche Wirksamkeit.`;
